export default function NeighborSizes({ t, neighbors, systemId, systemLabel, onPick }) {
  if (!neighbors?.smaller && !neighbors?.larger) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-3">
      <span className="text-xs text-slate-500 w-full">{t.neighbors.label}</span>
      {neighbors.smaller && (
        <button
          type="button"
          onClick={() => onPick(neighbors.smaller[systemId])}
          className="text-xs rounded-lg border border-slate-600 px-3 py-1.5 text-slate-300 hover:border-emerald-600/50 hover:text-emerald-300"
        >
          ↓ {systemLabel} {neighbors.smaller[systemId]}
        </button>
      )}
      {neighbors.larger && (
        <button
          type="button"
          onClick={() => onPick(neighbors.larger[systemId])}
          className="text-xs rounded-lg border border-slate-600 px-3 py-1.5 text-slate-300 hover:border-emerald-600/50 hover:text-emerald-300"
        >
          ↑ {systemLabel} {neighbors.larger[systemId]}
        </button>
      )}
    </div>
  );
}
